import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCodaComponent } from './simple-icons-coda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCodaComponent ],
    exports:      [ SimpleIconsCodaComponent ],
    bootstrap:    []
})
export class SimpleIconsCodaModule {}
